import React from "react";
import { useDispatch } from "react-redux";

import { Skeleton, Button } from "components";
import { useLoader } from "hooks";
import { uiActions } from "store";
import { LogoPath } from "types";

import { WarningUploadLogo } from "./warningUploadLogo";

import { ReactComponent as RemoveIcon } from "static/images/cancel.svg";
import DefaultLogo from "static/images/default_upload_logo.svg";
import { ReactComponent as EditIcon } from "static/images/pencil.svg";
import styles from "./uploadLogoAgentOffice.module.scss";

type UploadLogoAgentOfficeProps = {
	logoPath: LogoPath;
	deleteLogo: Function;
	handleAttachLogo: Function;
	title?: string;
	isLoading?: boolean;
	isDisabled?: boolean;
};

export const UploadLogoAgentOffice = ({
	logoPath,
	deleteLogo,
	handleAttachLogo,
	title,
	isLoading = true,
	isDisabled = false,
}: UploadLogoAgentOfficeProps) => {
	const dispatch = useDispatch();
	const Loader = useLoader(isLoading);

	const showLogoModal = () => {
		dispatch(
			uiActions.showModal("ADD_LOGO", {
				title: title,
				handleSubmit: handleAttachLogo,
				origin: "agent",
				logoPath,
			}),
		);
	};

	return (
		<div
			className={styles.wrapperLogo}
			style={isDisabled ? { pointerEvents: "none" } : {}}
		>
			<div className={styles.wrappLogo}>
				<Loader
					skeleton={<Skeleton height={100} width={370} />}
					component={
						<div
							onClick={showLogoModal}
							className={styles.logoContainer}
						>
							<img
								className={styles.logo}
								src={logoPath || DefaultLogo}
								alt="Logo"
							/>
						</div>
					}
				/>

				<div className={styles.wrappBtnAddLogo}>
					<div className={styles.wrappRemoveIcon}>
						<Button
							icon={<RemoveIcon />}
							btnIcon
							variant="secondary"
							size="sm"
							onClick={deleteLogo}
							className={`${styles.removeIcon}`}
							disabled={!logoPath || isDisabled || isLoading}
						/>
					</div>
					<div className={styles.wrappEditIcon}>
						<Button
							onClick={showLogoModal}
							icon={<EditIcon />}
							btnIcon
							variant="secondary"
							size="sm"
							className={styles.editIcon}
							disabled={isDisabled || isLoading}
						/>
					</div>
				</div>
			</div>
			<WarningUploadLogo />
		</div>
	);
};
